module.exports = __webpack_public_path__ + "static/media/columbus.a87d4d88.jpeg";